export const getErrorMessage = (error: unknown) => {
  const errorMessage =
    typeof error === "object" && error !== null && "message" in error
      ? String((error as { message: unknown }).message)
      : String(error);
  return errorMessage;
};
